<template>
    <div class="row g-0">
        <div class="col-12 col-sm-12 col-md-12 col-lg-10">
            <div class="right-side-bar-main-sec deposit_section withdraw_section">
                <div class="go-to-back-sec justify-content-between align-items-center">
                    <a @click="$router.back()">
                        {{ $t('back', 'Back') }}
                    </a>
                    <div class="withdrawal-sec">
                        <button type="button" data-bs-toggle="modal" data-bs-target="#acc-open-model">
                            <!-- <span>
                                <i class="fa-solid fa-plus"></i>
                            </span>  -->
                            {{ $t('add-account', 'Add account') }}
                        </button>
                    </div>
                </div>
                <div class="dw_bg_cl">
                    <div class="container-fluid">
                        <div class="withdrawal-main-body">
                            <div class="row">
                                <div class="col-12 col-sm-12 col-md-12 col-lg-8">
                                    
                                    <div class="depo-lft-container account_detail_cl">
                                        <div  class="add-acc_summary" v-if="!accountsList || accountsList?.length == 0">
                                            <div  class="paymentAccount-nodata">
                                                <span >Add Acccount To Withdraw...</span>
                                            </div>
                                        </div>

                                        <div class="account_data_parent description-card-withdraw avil_balance_container">
                                            <div class="row">
                                                <div v-for="(item, index) in accountsList" :key="index" class="col-12">
                                                <div class="accountItem account-card online-payment-mode-body" :class="{ 'selected-card': selectedCardIndex === index, 'non-selected-card': selectedCardIndex !== index && selectedCardIndex !== null }"  @click="selectCard(index, item)">
                                                    <div class="account-wrap">
                                                        <h5 class="account-title">{{ item?.method_name}}</h5>
                                                        <button type="button" @click="selectedRemoveAcc = item; openDeleteModal()"  class="delete-account-btn">
                                                            <i class="fa-solid fa-trash"></i>
                                                        </button>
                                                    </div>
                                                    <div class="accountItem-data">
                                                        <p class="card-text" v-if="item?.payment_method">
                                                            {{ $t('payment-type', 'Payment Type') }} : <span>{{ item?.payment_method }}</span>
                                                            <button class="btn txt_copy_cl" @click="copyPaymentData(this.$t('payment-method', 'Payment Method'), item.payment_method)">
                                                                <i class="fa-solid fa-copy"></i>
                                                            </button>
                                                        </p>
                                                        <p class="card-text" v-if="item?.account_number || item?.phone_number"> {{ $t('ac-number', 'A/C Number') }} : 
                                                            <span>{{ item?.account_number ? item?.account_number : item?.phone_number }}</span>
                                                            <button class="btn txt_copy_cl" @click="copyPaymentData(item?.account_number ? $t( 'ac-number', 'A/C Number') : ('phone-number', 'Phone Number'), item?.account_number ? item?.account_number : item?.phone_number)">
                                                                <i class="fa-solid fa-copy"></i>
                                                            </button>
                                                        </p>
                                                        <p class="card-text" v-if="item?.payment_method == 'bank' && item?.ifsc_code">
                                                            {{ $t('ifsc-code', 'IFSC Code') }} : 
                                                            <span>{{ item?.ifsc_code }}</span>
                                                            <button class="btn txt_copy_cl"  @click="copyPaymentData($t('ifsc-code', 'IFSC Code'), item?.ifsc_code)">
                                                                <i class="fa-solid fa-copy"></i>
                                                            </button>
                                                        </p>
                                                        <p class="card-text"  v-if="item?.payment_method == 'upi' && item?.upi_id">
                                                            {{ $t('upi-id', 'UPI ID') }} : 
                                                            <span>{{ item?.upi_id }}</span>
                                                            <button class="btn txt_copy_cl"  @click="copyPaymentData($t('upi-id', 'UPI ID') , item?.upi_id)">
                                                                <i class="fa-solid fa-copy"></i>
                                                            </button>
                                                        </p>
                                                        <p class="card-text" v-if="item?.payment_method == 'wallet' && item?.crypto_wallet_id">
                                                            {{ $t('wallet-id', 'Wallet ID') }} : 
                                                            <span>{{ item?.crypto_wallet_id }}</span>
                                                            <button class="btn txt_copy_cl"  @click="copyPaymentData($t('wallet-id', 'Wallet ID'),item?.crypto_wallet_id)">
                                                                <i class="fa-solid fa-copy"></i>
                                                            </button>
                                                        </p>
                                                        <p class="card-text" >{{ $t('account-holder-name', 'Account Holder’s Name') }} : 
                                                            <span>{{ item?.account_holder_name }}</span>
                                                            <button class="btn txt_copy_cl"  @click="copyPaymentData(this.$t('account-holder-name', 'Account Holder’s Name'), item?.account_holder_name)">
                                                                <i class="fa-solid fa-copy"></i>
                                                            </button>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <template v-if="accountsList && accountsList?.length > 0">
                                                <form class="withdrawalForm">
                                                    <div class="wallet-minmax amount_avil_bal_sec">
                                                        <label for="">
                                                            {{ $t('Withdraw Amount','Withdraw') }}
                                                        </label>
                                                        <span>
                                                            {{ $t('available-amount','Avail Bal') }}: {{ $helper.checkDecimalNumber($auth.user?.balance + parseInt($auth.user?.exposure || 0) - parseInt($auth.user.earnBonus || 0)) }}
                                                        </span>
                                                    </div>
                                                    <input type="number" id="amount" maxlength="10" @input="amount = $helper.sanitizeNumber(+amount, +walletConfig?.withdrawal_range?.max || 99999999)" class="form-control withdraw_amount_input" :placeholder="$t('enter-amount','Enter Withdraw amount')" v-model="amount">
                                                    <div class="wallet-minmax">{{ $t('min', 'Min') }}: {{ walletConfig?.withdrawal_range?.min }} | {{ $t('max', 'Max') }}: {{ walletConfig?.withdrawal_range?.max }}</div>
                                                    <button :class="{'btn-disabled' : amount < walletConfig?.withdrawal_range?.min }" type="button" class="withdrawBtn" @click="withdrawAmountFuncCall()">
                                                        {{ $t('withdraw', 'Withdraw') }}
                                                    </button>
                                                </form>

                                                <div class="depo-lft-container">
                                                    <div class="description-card-body p-0">
                                                        <div class="row">
                                                            <div class="col-12">
                                                                <WalletInstructions instructionType="withdrawal" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>

                                            <div class="delete_account_modal">
                                                <div class="modal fade worli-Bets-Modal" id="editnavModal" ref="deleteModalRef" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                                    <div class="modal-dialog modal-dialog-centered">
                                                        <DeleteAccount  v-if="selectedRemoveAcc" @yes-click="removeAccountHere()" @close="closeModal()" />
                                                    </div>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-12 col-md-12 col-lg-4">
                                    <div class="withdrawal-rgt-container deposit_amount_table_cl">
                                        <div class="wallet_thm_title">
                                            <h2>Transaction History</h2>
                                        </div>
                                        <WalletHistory  ref="wallet_history"></WalletHistory>
                                    </div>
                                </div>
                            </div>
                            <div class="tutorailVideo-sec">
                                <TutorialVideo type = "1"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
<AddBankAccount ref="addBankRef" :paymentMethodList="paymentMethodList" @open-withdraw-password-modal="openWithdrawPasswordModal()" @getAccountDetailList = "getUserAccounts"/>
<WithdrawalPasswordSetReset ref="withdrawSetReset" :triggerAddAccountMethod="triggerAddAccountMethod"/>
    <div class="modal fade withdraw-password-continue" id="cancelbetModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"
            data-bs-backdrop="static" data-bs-keyboard="false">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header headerTheme">
                        <h5>{{$t('withDraw-password','Withdraw password')}}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                            <i class="fa-solid fa-xmark"></i>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="account-delete-msg">
                            <p>{{$t('skip-msg','Withdraw password not set. Continue to add or skip')}}..!!</p>
                        </div>
                        <div class="header-but  info-footer">
                            <button type="button" class="thm-but thm-bor-but" data-bs-dismiss="modal" @click="addAccountServiceCall(true)">{{ $t('skip','Skip') }}</button>
                            <a @click="openWithdrawPasswordModal()" data-bs-dismiss="modal" class="thm-but ">{{ $t('continue', 'Continue') }}</a>
                        </div>
                    </div>
                </div>
            </div>
    </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import {withdrawAmountClickValidation} from '../services/walletWithdraw';
import {getUserAccounts, withdrawWalletAmount, removeAccount} from '../services/withdrawDetails';
import { addAccount, openWithdrawPasswordModal} from "../services/withdrawAccountDetails"
import WalletInstructions from '../components/WalletInstructions.vue';
import TutorialVideo from '../components/TutorialVideo.vue';
import WalletHistory from '../components/WalletHistory.vue';
import DeleteAccount from '../components/DeleteAccount.vue';
import WithdrawalPasswordSetReset from '../components/WithdrawalPasswordSetReset.vue';
import NoDataFound from '@/shared/components/no-data/NoDataFound.vue';
import AddBankAccount from '../components/AddBankAccount.vue';

export default {
    name: "WalletWithdraw",
    inject: ['walletConfig','onlyBank'],
    components: {
        AddBankAccount,
        NoDataFound,
        WithdrawalPasswordSetReset,
        DeleteAccount,
        WalletHistory,
        TutorialVideo,
        WalletInstructions,
    },
    data() {
        return {
            is_withdrawal_password_set:false,
            amount: '',
            loading: false,
            walletData: null,
            accountsList: [],
            selectBankId: null,
            onlyBankStatus: false,
            selectedRemoveAcc: null,
            copiedText: null,
            selectedCardIndex: null,
            withdrawAccountType: '',
            paymentMethodList:null
        }
    },
    mounted() {
        this.walletData = this.walletConfig;
        this.getUserAccounts();
        // this.getWalletLimitsServiceCall();
        // this.isWithdrawalPasswordSet()
	},
    computed:{
        withdrawlBalance() {
            let { balance = 0, expl = 0 } = this.$auth?.user || {};
            let earnBonus = this.$store.getters?.user?.earnBonus || 0;
            return (parseFloat(balance) + parseFloat(expl || 0) - parseFloat(earnBonus)).toFixed(2);
        }
    },
	methods: {
        async getUserAccounts() {
            let response = await getUserAccounts(this.walletConfig?.payment_method)
            this.accountsList = response?.userAccounts;
            this.withdrawAccountType = response?.withdrawAccountType;
            this.paymentMethodList = response?.paymentMethods;
            if(this.accountsList && this.accountsList?.length > 0) {
                this.selectUserAccount (this.accountsList?.[0]);
                this.selectedCardIndex = 0;
                this.selectBankId = this.accountsList[0].client_account_id;
            }
        },
        selectUserAccount(account){
            this.withdrawAccountType = {
                type : account.bank_name ? account.bank_name : account.payment_type_name,
                holderName: account.account_holder_name
            };
        },
        async addAccount(){
            this.v$.$touch();
			if (this.v$.$error) {
				// this.$errorToast('Please fill the required fields');
				return;
			}
            let response = await addAccount(this.paymentMethod, this.type, this.bankDetails, this.upiDetails)
            if(response){
            }
        },
        triggerAddAccountMethod(){
            this.addAccount();
        },
		async openWithdrawPasswordModal(){
            let response = await openWithdrawPasswordModal()
            if(!response?.error){
                this.$helper.openModal('#withdrawalPassword');
                this.$refs.withdrawSetReset.otpHasBeenCalled();
                this.$refs.withdrawSetReset.resetTimer();
            }else{
                this.$errorToast(message);
            }
        },
        addAccountServiceCall(){
            this.$refs.addBankRef.addAccountServiceCall(true);
        },
        isWithdrawalPasswordSet(){
            try {
                this.$apiCall('get', 'CHECK_WITHDRAWAL_PASSWORD', null, 'wallet', null).then(res => {
                    if (res.status === 200) {
                        this.is_withdrawal_password_set = res.data.success;
                        return this.is_withdrawal_password_set;
                    } else {
                        return false;
                    }
                });
                
            } catch (error) {
                const message = sendError(error);
                console.log("============",message)
            }
        },
        selectCard(index, item) {
            this.selectedCardIndex = index;
            this.selectBankId = item.client_account_id;
            this.selectUserAccount(item)
        },
        openDeleteModal() {
			this.$nextTick(() => {
                this.$helper.openModal('#editnavModal')
			});
		},
        async removeAccountHere() {
            let response = await removeAccount(this.selectedRemoveAcc.client_account_id)
            if(response) {
                this.closeModal();
                this.getUserAccounts();
            }
		},
		closeModal() {
            this.selectedRemoveAcc = null;
			const closeButton = document.getElementById('closeBtn');
            if (closeButton) {
                closeButton.click();
            }
		},
        async withdrawAmountFuncCall() {
            if(this.amount < (this.walletData?.withdrawal_range?.min || 100)){
                return false;
            }
            withdrawAmountClickValidation(this.amount, this.walletConfig, this.withdrawlBalance)
            if (this.amount > this.$auth?.user?.balance) {
                this.$errorToast('Insufficient balance.');
                return false;
            }
            this.$store.dispatch('setGlobalLoader', true);
            console.log('acc', this.accountId)
            let response = await withdrawWalletAmount(this.amount, this.selectBankId)
            if(!response?.error){
                this.$router.push({ name: 'Home' });
            }
		},
        
        copyPaymentData(catagory, accountData) {
            if (navigator.clipboard) {
                navigator.clipboard.writeText(accountData).then(() => {
                    this.$successToast(catagory + ' Copied Successfully');
                }).catch(err => {
                    console.error("Failed to copy text");
                });
            } else{
                var input = document.createElement('textarea');
                input.innerHTML = accountData;
                document.body.appendChild(input);
                input.select();
                document.execCommand('copy');
                document.body.removeChild(input);
                this.copiedText = accountData;
                this.$successToast(catagory + ' Copied Successfully');

            }
            document.querySelectorAll('.copt_btn_toolTips .copty_cmn_btn i').forEach(el => {
                el.style.color = ''; 
            });
            setTimeout(() => {
                this.copiedText = null;
                document.querySelectorAll('.copty_cmn_btn i').forEach(el => {
                    el.style.color = '#0cddff';
                });
            }, 1000);
        },
        enterAvailableBalanceToWithdraw(){
            this.amount = this.$helper.sanitizeNumber(Math.floor(this.availableBalance), +this.walletData?.withdrawal_range?.max || 99999999)
        },
	}
   
}
</script>
<style scoped>
.btn-disabled{
  pointer-events: none;
  opacity: 0.5;
}
</style>